import Helpers from './Helpers';
var Big = require('big.js');
export default {
    getProductPriceToDisplay: (product) => {
        return Helpers.FloatToReais(product.Bulk ?
            Number(new Big(product.Price).times(product.QtyToDisplayPrice)) :
            product.Price);
    }
}